import {Fade} from '@travel-frontend/ui-components';
import {useCallback, useRef, useState} from 'react';

import {useIsVisible} from '@/components/ImageGalleryMosaic/hooks/useIsVisible';

type Props = {
  src: string;
  alt?: string;
};

export const Image: React.FunctionComponent<Props> = ({src, alt}) => {
  const [hasFinishedLoading, setHasFinishedLoading] = useState(false);
  const placeholderRef = useRef<HTMLDivElement>(null);
  const isVisible = useIsVisible(placeholderRef);

  const handleLoad = useCallback(() => {
    setHasFinishedLoading(true);
  }, []);

  return isVisible ? (
    <Fade in={hasFinishedLoading} mountOnEnter={false} unmountOnExit={false}>
      <img src={src} alt={alt} onLoad={handleLoad} />
    </Fade>
  ) : (
    <div ref={placeholderRef} />
  );
};
